<template>
  <div>
    <portal target-el="#filter">
      <primary-filter
        :noSearchFilter="true" />
    </portal>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: { PrimaryFilter },
  created() {
    const token = localStorage.getItem('tsm-user-token');
    const baseUrl = this.$route.query.serviceUrl;
    const hasFeature = this.$hasFeature('control_tower');
    if (hasFeature) {
      const url = `https://${baseUrl}?token=${token}`;
      window.open(url, '_self');
    } else {
      this.$errorMessage({ message: this.$getErr('ERR_CONFIG_MISSING') });
    }
  },
};
</script>
